import { render } from "./Definatom.vue?vue&type=template&id=064c9bf7&scoped=true"
import script from "./Definatom.vue?vue&type=script&lang=js"
export * from "./Definatom.vue?vue&type=script&lang=js"

import "./Definatom.vue?vue&type=style&index=0&id=064c9bf7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064c9bf7"]])

export default __exports__